/**
 * useArenaStatus — fetches my Arena membership + active check-in state.
 * Polls every 60s while mounted.
 */
import { useEffect, useState } from "react";
import { apiClient } from "../services/api";
import { useAuthStore } from "../store/authStore";

export default function useArenaStatus() {
  const user = useAuthStore((s) => s.user);
  const [data, setData] = useState({ member: null, gym: null, active_checkin: null, trainer_note_today: null });
  const [loading, setLoading] = useState(true);
  const reload = () => {
    if (!user) {
      setData({ member: null, gym: null, active_checkin: null, trainer_note_today: null });
      setLoading(false);
      return;
    }
    apiClient.get("/arena/me")
      .then((r) => setData(r.data || {}))
      .catch(() => setData({ member: null, gym: null, active_checkin: null, trainer_note_today: null }))
      .finally(() => setLoading(false));
  };
  useEffect(() => {
    reload();
    if (!user) return undefined;
    const id = setInterval(reload, 60_000);
    return () => clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);
  return { ...data, loading, reload };
}
